import './ProductImageView.less';
import React, {useState, useEffect} from 'react';
import AspectContainer from "../../../components/aspect-container/AspectContainer";
import Images from '../../../models/image/Images';

export default function ProductImageView({avatarImage, hoverImage = null}) {

    const [focused, setFocused] = useState(false);

    return <div
        className={`product-image-view ${focused ? 'focused' : ''}`}

        onMouseEnter={() => setFocused(true)}
        onMouseLeave={() => setFocused(false)}

        onTouchStart={() => setFocused(true)}
        onTouchEnd={() => setFocused(false)}
        onTouchCancel={() => setFocused(false)}
    >
        <AspectContainer ratio={1}>
            <img
                src={Images.getUrl(avatarImage)}
                srcSet={Images.getAttrSrcset(avatarImage)}
                sizes={Images.getAttrSizes(avatarImage)}
                title={avatarImage.title}
                alt={avatarImage.title}
            />
            {
                hoverImage !== null &&
                <img
                    src={Images.getUrl(hoverImage)}
                    srcSet={Images.getAttrSrcset(hoverImage)}
                    sizes={Images.getAttrSizes(hoverImage)}
                    title={hoverImage.title}
                    alt={hoverImage.title}
                />
            }
        </AspectContainer>
    </div>;
}
